export enum DesignSystemColor {
  //Base Colors
  DarkSeaGreen = '#159953',
  White = '#ffffff',
  Black = '#000000',
  LightBlack = '#242424',
  Gray = '#bebebe',

  //Background Colors
  BgColorGreen10 = '#1599530a',
  BgColorBlack10 = '#2424240a',
  BgColorWhite = White,
  BgColorBlack = Black,

  //Text Colors
  PrimaryText = DarkSeaGreen,
  BlackText = LightBlack,
  WhiteText = White,
  DisabledText = Gray,
}
